import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

type Props = {
  price: string;
  setPrice: (price: string) => void;
};

const EventMutationSetLimitPrice = ({ price, setPrice }: Props) => {
  const handleChangePrice = (price: string) => {
    if (price && !/^[0-9]+$/.test(price)) return;
    if (price.includes('.') || price.includes('-')) return;
    if (!price) {
      setPrice('');
      return;
    }
    const value = Number(price);
    if (!isNaN(value) && (value > 99 || value < 1)) return;

    setPrice(price);
  };

  const handleAddPrice = (value: number) => {
    const priceValue = isNaN(Number(price)) ? 0 : Number(price);

    if (!isNaN(value) && (priceValue + value > 99 || priceValue + value < 1))
      return;

    setPrice((priceValue + value).toString());
  };

  return (
    <div className="flex flex-row items-center gap-2">
      <div className="grow text-[14px] text-[#767676]">Limit Price</div>
      <Button
        onClick={() => handleAddPrice(-1)}
        disabled={isNaN(+price) || +price === 1}
        size="medium"
        variant="secondary"
        className="h-8 w-8 text-xl"
      >
        -
      </Button>

      <div className="relative">
        <input
          className="h-[32px] w-[96px] bg-transparent text-center text-[24px] tabular-nums outline-none placeholder:text-[#767676]"
          value={price}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          placeholder="0"
          onChange={(e) => handleChangePrice(e.target.value)}
        />
        <p
          className={cn(
            'absolute top-0 text-[24px]',
            !price && 'text-[#767676]',
            !price || price.length === 1 ? 'right-[26px]' : 'right-[18px]',
          )}
        >
          ¢
        </p>
      </div>

      <Button
        onClick={() => handleAddPrice(1)}
        disabled={isNaN(+price) || +price === 99}
        size="medium"
        variant="secondary"
        className="h-8 w-8 text-xl"
      >
        +
      </Button>
    </div>
  );
};

export default EventMutationSetLimitPrice;
